module.exports = __webpack_public_path__ + "img/prayer.59b20eb8.png";